import { Box, Checkbox, FormControlLabel } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { questionParser } from '.'
import { AppDispatch } from '../../store'
import questionsSelector from '../../store/questions/questionsSelector'
import {
  updateNewCaseAnswerOption,
  updateVictimAnswerOption,
} from '../../store/questions/questionsSlice'
import { findItemByUuid } from '../../store/reports/reportsSlice'
import { IQuestionV2, MainObject } from '../../store/reports/types'
import DividerTAG from '../DividerTAG'
import LabelErrorTAG from '../LabelErrorTAG'

interface IMultipleSelectQuestion {
  question: IQuestionV2
  answers?: MainObject[]
  victimQuestionId?: number | null
}
const MultipleSelectQuestion: React.FC<IMultipleSelectQuestion> = ({
  question,
  answers,
  victimQuestionId = null,
}) => {
  const getAnswer = () => {
    if (victimQuestionId) {
      return useSelector(questionsSelector.getVictimAnswer(victimQuestionId, question?.uuid))
    }
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, question?.uuid)
    }
    return useSelector(questionsSelector.answerToNewCaseQuestion(question?.uuid))
  }
  const answer = getAnswer()
  const dispatch = useDispatch<AppDispatch>()

  const optionsAndSubquestions = question?.options.map((option, index) => {
    const found = question?.subquestions.filter(subQuestion => subQuestion?.option === option.id)
    return found?.length > 0
      ? {
          option,
          subquestions: found,
        }
      : {
          option,
        }
  })

  optionsAndSubquestions.sort((a, b) => {
    if (a.option.id === 30) return 1
    if (b.option.id === 30) return -1
    return 0
  })

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event?.target?.checked) {
      if (victimQuestionId) {
        dispatch(
          updateVictimAnswerOption({
            victimId: victimQuestionId,
            answerUUID: answer?.uuid,
            answerText: [...(answer?.options ?? []), event?.target?.value as unknown as number],
          }),
        )
        return
      }

      dispatch(
        updateNewCaseAnswerOption({
          answerUUID: answer?.uuid,
          answerText: [...(answer?.options ?? []), event?.target?.value as unknown as number],
        }),
      )
      return
    }
    const filteredOptions = answer?.options?.filter(
      option => option !== (event?.target?.value as unknown as number),
    )
    if (victimQuestionId) {
      dispatch(
        updateVictimAnswerOption({
          victimId: victimQuestionId,
          answerUUID: answer?.uuid,
          answerText: filteredOptions,
        }),
      )
      return
    }

    dispatch(
      updateNewCaseAnswerOption({
        answerUUID: answer?.uuid,
        answerText: filteredOptions,
      }),
    )
  }

  const resolveChecked = (optionId: number) => {
    if (!answer) return false

    return answer?.options?.filter(id => id == optionId).length > 0
  }

  const renderOptions = () => {
    return optionsAndSubquestions.map(option => {
      const hasChildQuestions = Object.prototype.hasOwnProperty.call(option, 'subquestions')

      if (!hasChildQuestions) {
        return (
          <>
            <FormControlLabel
              control={
                <Checkbox
                  value={option?.option.id}
                  onChange={onChangeHandler}
                  checked={resolveChecked(option?.option.id)}
                />
              }
              label={option?.option.text}
            />
            <DividerTAG />
          </>
        )
      }

      return (
        <Box sx={{ width: '100%' }} key={option?.option?.id}>
          <FormControlLabel
            control={
              <Checkbox
                value={option?.option.id}
                onChange={onChangeHandler}
                checked={resolveChecked(option?.option.id)}
              />
            }
            label={option?.option.text}
          />
          <Box sx={{ width: '100%', paddingLeft: '2rem', boxSizing: 'border-box' }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              {resolveChecked(option?.option.id) &&
                option?.subquestions?.map(subquestion =>
                  questionParser(subquestion, false, victimQuestionId),
                )}
            </Box>
          </Box>
          <DividerTAG />
        </Box>
      )
    })
  }
  return (
    <>
      <LabelErrorTAG label={question?.variant?.label} />
      {renderOptions()}
    </>
  )
}

export default MultipleSelectQuestion
